import cloneDeep from 'lodash/cloneDeep';

import fseTheme from '../../themes/fse/theme';

const manualTheme = cloneDeep(fseTheme);
manualTheme.id = 'fremanual';
manualTheme.name = 'fregijp';
manualTheme.logo = 'FRESENIUS_MANUAL';
manualTheme.logoMobile = 'FRESENIUS_MANUAL';
manualTheme.jobDetail.automaticTranslation = true;
manualTheme.hasShareSection = false;

manualTheme.header.showFavourites = false;
manualTheme.header.showFollowUs = false;
manualTheme.header.showContentSearch = false;
manualTheme.header.showCountrySwitch = false;
manualTheme.footer.showBigFooter = false;

manualTheme.footer.logoFooter = 'FRESENIUS_SE';

export { manualTheme };
